import React, { ErrorInfo } from "react";

import Spinner from "./spinner";
import { errorMessage } from "../../Utils/useRequest";
import styles from "./index.module.scss";
import classNames from "classnames";

export interface BoundaryProps {
    className?: string;
    errorFallback?: (error: Error | null) => React.ReactNode;
    spinner?: React.ReactElement;
}

export default class Boundary extends React.Component<BoundaryProps> {
    state = {
        error: null
    };

    static getDerivedStateFromError(error: any) {
        return { error };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {}

    render() {
        if (this.state.error) {
            if (this.props.errorFallback) {
                return this.props.errorFallback(this.state.error);
            }

            return (
                <div className={classNames(this.props.className, styles.error)}>
                    {errorMessage(this.state.error)}
                </div>
            );
        }

        return (
            <React.Suspense fallback={this.props.spinner || <Spinner />}>
                {this.props.children}
            </React.Suspense>
        );
    }
}
